import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer.js";
import { CaretDownOutlined, CloseCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import TableResultComponent from "./TableResultComponent";
import { Button, Space, Tabs, Tooltip } from "antd";
import { Content } from "antd/es/layout/layout";
import i18next, { use } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { useFeatureLayer } from "../../../../hooks/useFeatureLayer";
import { table_state, removeTableName, resetTableNames } from "../../../../features/table/tableSlice";
import { resetQueries } from "../../../../features/queries/queriesSlice";


const TableComponent = forwardRef(({ mapDiv, mapView, tableVisible, tableSize, setTableVisible }, ref) => {

    //CutomHook
    const { featureLayerCustom, crearFeatureLayerCustom, setFeatureLayerCustom } = useFeatureLayer();


    const [tablesResults, setTablesResults] = useState([]);
    const [tabActiveKey, setTabActiveKey] = useState();
    const [nextTabActive, setNextTabActive] = useState(null);


    const dispatch = useDispatch();
    const tableState = useSelector(table_state);

    useImperativeHandle(ref, () => ({
        hasResults() {
            return ref.current.tablesResults != null && ref.current.tablesResults.length > 0
        },
        addByFeature(mapView, mapLayer, sublayer, feature) {

            const { findBy, content } = feature
            //console.log('actua addByFeature')

            /*console.log("mapView", mapView)
            console.log("mapLayer", mapLayer)
            console.log("sublayer", sublayer)
            console.log("feature", feature)*/
            crearFeatureLayerCustom(mapView, mapLayer, sublayer)
                .then(function (featureLayer) {
                    return featureLayer.load();
                }).then(function (featureLayer) {
                    if (findBy == 'id') {
                        featureLayer.definitionExpression = featureLayer.objectIdField + "=" + content.attributes[featureLayer.objectIdField];
                    }
                    if (findBy == 'query') {
                        featureLayer.definitionExpression = content
                    }
                    createParameters(mapView, mapLayer, sublayer, featureLayer, ref)
                });


            /*function createParameters(featureLayer) {
                //console.log("featureLayer", featureLayer)

                //dependiendo del valor de findBy se crea una expresion u otra
                if (findBy == 'id') {
                    featureLayer.definitionExpression = featureLayer.objectIdField + "=" + content.attributes[featureLayer.objectIdField];
                }
                if (findBy == 'query') {
                    featureLayer.definitionExpression = content
                }

                let layer = new GraphicsLayer({
                    graphics: [],
                    listMode: "hide"
                });

                mapView.map.add(layer);

                setTableVisible(true);
                ref.current.tablesResults = ref.current.tablesResults ? [...ref.current.tablesResults] : [];
                ref.current.tablesResults.push({
                    mapLayer: mapLayer,
                    sublayer: sublayer,
                    featureLayer: featureLayer,
                    graphicLayer: layer
                });
                setTablesResults(ref.current.tablesResults);
                //console.log('some', String(ref.current.tablesResults.length))
                setTabActiveKey(String(ref.current.tablesResults.length));
            }*/
        },

        addLayer(mapView, mapLayer, sublayer, layer) {
            //console.log('actua addLayer')

            crearFeatureLayerCustom(mapView, mapLayer, sublayer)
                .then(function (featureLayer) {
                    return featureLayer.load();
                }).then(function (featureLayer) {
                    createParameters(mapView, mapLayer, sublayer, featureLayer, ref)
                });

            /*function createParameters(featureLayer) {
    //console.log("featureLayer", featureLayer)


    let layer = new GraphicsLayer({
        graphics: [],
        listMode: "hide"
    });

    mapView.map.add(layer);

    setTableVisible(true);
    ref.current.tablesResults = ref.current.tablesResults ? [...ref.current.tablesResults] : [];
    ref.current.tablesResults.push({
        mapLayer: mapLayer,
        sublayer: sublayer,
        featureLayer: featureLayer,
        graphicLayer: layer
    });
    setTablesResults(ref.current.tablesResults);
    //console.log('some', String(ref.current.tablesResults.length))
    setTabActiveKey(String(ref.current.tablesResults.length));
}*/
        }
    }), []);

    function createParameters(mapView, mapLayer, sublayer, featureLayer, ref) {

        //se crea el id del obajeto
        let uuid = Math.random().toString(36).slice(-6);

        let layer = new GraphicsLayer({
            graphics: [],
            listMode: "hide"
        });

        mapView.map.add(layer);


        ref.current.tablesResults = ref.current.tablesResults ? [...ref.current.tablesResults] : [];
        ref.current.tablesResults.push({
            id: uuid,
            mapLayer: mapLayer,
            sublayer: sublayer,
            featureLayer: featureLayer,
            graphicLayer: layer
        });
        //console.log('table results', ref.current.tablesResults)
        setTablesResults(ref.current.tablesResults);
        //console.log('some', String(ref.current.tablesResults.length))
        setTableVisible(true);
        setTabActiveKey(uuid);
    }
    /*
    const addFeatures = (mapLayer, sublayer, features) => {
        ref.current.tablesResults = ref.current.tablesResults ? [...ref.current.tablesResults] : [];
        ref.current.tablesResults.push({
            mapLayer: mapLayer,
            sublayer: sublayer,
            features: features
        });
        setTablesResults(ref.current.tablesResults);
        setTabActiveKey(String(ref.current.tablesResults.length));
    };*/

    /**
     * Cuando se cierra una tabla, conseguir que se muestre la de su derecha o si no hay, 
     * que se muestre la de la izq
     */
    const setNextActiveTable = (table, result) => {
        let index = table.indexOf(result)
        //console.log('index', index)

        //hay elemento por la derecha
        if (table.length - 1 > index) {
            let element = table[index + 1]
            setNextTabActive(element)
            //hay elemento por la izq
        } else if (index > 0) {
            let element = table[index - 1]
            setNextTabActive(element)
        } else {

        }
    }

    const removeResult = (id) => {
        let tablesResultsAUx = [...tablesResults];

        //console.log('index', index)
        
        let result = tablesResultsAUx.find((result) => result.id == id)

        setNextActiveTable(tablesResultsAUx, result)

        let graphicLayer = result.graphicLayer

        mapView.map.remove(graphicLayer);

        let tableResultsCopy = tablesResultsAUx.filter((result) => result.id != id)

        //Se resetea el state de queriesSlice
        if(tableResultsCopy.length==0) {
            dispatch(resetQueries())
        }

        setTablesResults(tableResultsCopy);
        ref.current.tablesResults = tableResultsCopy;

        //Ocultamos la tabla si no tenemos resultados
        if (ref.current.tablesResults == null || ref.current.tablesResults.length == 0) {
            setTableVisible(false);
        }
    }

    const removeAll = () => {
        setTablesResults([]);
        ref.current.tablesResults = [];
        //Elimina todos los graphics de selección del mapa
        mapView.map.allLayers.forEach(function (layer) {
            if (layer.type === "graphics") {
                layer.removeAll();
            }
        });
        //Ocultamos la tabla si no tenemos resultados
        setTableVisible(false);
    }

    /*const getViewMapLayer = (mapView, mapLayer) => {
        let out = null;
        for (let layerView of mapView.layerViews) {
            if (layerView.layer.title == mapLayer.name) {
                out = layerView.layer;
            }
        }
        //console.log("getMapLayer", out)
        return out;
    }*/

    /*const getViewSublayer = (mapView, mapLayer, sublayer) => {
        let out = null;
        let allSublayers = getViewMapLayer(mapView, mapLayer).allSublayers;
        for (let sl of allSublayers) {
            if (sl.id == sublayer.id) {
                out = sl;
            }
        }
        //console.log("getSublayer", out)
        return out;
    }*/


    useEffect(() => {

        if (nextTabActive) {
            setTabActiveKey(nextTabActive.id)
        }

    }, [nextTabActive])

    return (
        <>
            {tablesResults &&
                <Content style={{ padding: '0 10px', overflow: 'auto' }}>
                    <div style={{ position: "absolute", top: "10px", right: "10px", zIndex: "100" }}>
                        <Space wrap>
                            <Tooltip title={i18next.t('common.delete_all')}>
                                <Button shape="circle" onClick={() => {removeAll(); dispatch(resetTableNames()); dispatch(resetQueries())}} icon={<DeleteOutlined />} />
                            </Tooltip>
                        </Space>
                        <Space wrap>
                            <Tooltip title={i18next.t('common.hide')}>
                                <Button shape="circle" onClick={() => setTableVisible(false)} icon={<CaretDownOutlined />} />
                            </Tooltip>
                        </Space>
                    </div>
                    <Tabs
                        activeKey={tabActiveKey}
                        onTabClick={(key, event) => { setTabActiveKey(key) }}
                        items={tablesResults.map((result, i) => {
                            //console.log('resultadoTabla ' + i, result.id)
                            //console.log('se renderiza')
                            return {
                                label: <>
                                    {result.sublayer.title + ' '}
                                    <Tooltip title={i18next.t('common.delete')} key={'common.delete'}>
                                        <CloseCircleOutlined onClick={() => {removeResult(result.id); dispatch(removeTableName(result.sublayer.title));}}></CloseCircleOutlined>
                                    </Tooltip>
                                </>,
                                key: result.id,
                                children: <>
                                    {
                                      /*tabActiveKey==result.id &&*/  <TableResultComponent tableSize={tableSize} id={result.id} mapDiv={mapDiv} mapView={mapView} ref={ref}
                                            mapLayer={result.mapLayer} sublayer={result.sublayer} featureLayer={result.featureLayer} graphicLayer={result.graphicLayer}
                                        ></TableResultComponent>
                                    }
                                </>


                            };
                        })}
                    />
                </Content>
            }
        </>
    )
});
export default TableComponent;